import * as React from 'react';

import { useRouter } from 'js/lib/useRouter';
import user from 'js/lib/user';

import type { InjectedNaptime } from 'bundles/naptimejs';
import { useProgram, useProgramMembership } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import BreadcrumbsModule from 'bundles/unified-description-page-common/components/modules/breadcrumbs/BreadcrumbsModule';
import EnterpriseBreadcrumbs from 'bundles/unified-description-page-common/components/modules/breadcrumbs/EnterpriseBreadcrumbs';
import SaveButton from 'bundles/unified-description-page-common/components/modules/breadcrumbs/SaveButton';
import { useIsWishlisted } from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseUserProductInfoContext';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import { saveProductFactory } from 'bundles/unified-description-page-common/utils/SaveProductManager';

type Props = {
  pageData: EnterpriseCoursePageFieldsFragment;
  config?: {
    removeLinksAboveFold: boolean;
    hideCtas?: boolean;
  };
  naptime: InjectedNaptime;
};

const EnterpriseCourseBreadcrumbsModuleRenderer = ({ pageData, config, naptime }: Props) => {
  const program = useProgram();
  const programMembership = useProgramMembership();
  const isWishlisted = useIsWishlisted();
  const {
    params: { programSlug },
  } = useRouter();

  const enterpriseSaveProductManager =
    program?.id &&
    programMembership.isProgramMember &&
    saveProductFactory.getEnterpriseCourseSaveProduct({
      programId: program.id,
      userId: user.get().id,
      naptime,
    });

  return (
    <BreadcrumbsModule
      breadcrumbs={
        !config?.removeLinksAboveFold ? (
          <EnterpriseBreadcrumbs domains={pageData.domains} programSlug={programSlug} />
        ) : undefined
      }
      ctas={
        enterpriseSaveProductManager
          ? [
              <SaveButton
                isWishlisted={isWishlisted}
                saveProductManager={enterpriseSaveProductManager}
                productId={pageData.id}
              />,
            ]
          : undefined
      }
    />
  );
};

export default EnterpriseCourseBreadcrumbsModuleRenderer;
